<template lang="pug">
  v-toolbar-title
    v-layout(
      justify-center
      align-center
      @click.prevent="$router.push({ path: '/' })" style="cursor:pointer")
      img(src="@/assets/logo/logo.svg" width=32 height=32 class="mr-1")
      span(class="subtitle-1 font-weight-bold text-uppercase pl-1 d-inline-block") Kluchi.kg
</template>

<script lang="js">
export default {
  name: 'Logo'
}
</script>
